import template from './component.tpl.html';
import AlGuestlistEditorPageOnlineCheckinComponentController from './controller';

angular
    .module('festzelt-os.modules.media')
    .component('alGuestlistEditorPageOnlineCheckin', {
        bindings: {
            guestlist: '<',
            onModelUpdate: '&',
            globalModel: '<',
            showContent: '<'
        },
        controller: AlGuestlistEditorPageOnlineCheckinComponentController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-editor/pages/online-checkin/component.js